import axios from 'axios'

const BASE_URL = 'https://umn7i1dac9.execute-api.us-west-1.amazonaws.com'

const BASE_WS_URL = 'wss://rnqfcm62c3.execute-api.us-west-1.amazonaws.com/staging'

export async function startCheck(content) {
  return axios
    .post(`${BASE_URL}/jobs`, { content })
    .then(resp => {
      if (resp.status === 202) {
        return resp.data.jobID || ''
      }

      return '';
    })
}

export async function checkResults(jobID) {
  return axios.get(`${BASE_URL}/jobs/${jobID}`).then(resp => resp.data || {})
}

export async function getDOMResults(location, content) {
  return axios
    .post(`${BASE_URL}/doms/${location}`, { content })
    .then(resp => resp.data || {})
}

export async function getWebSocketURL() {
  return BASE_WS_URL
}
